import React, { useRef, useState } from 'react';
import QRCode from 'react-qr-code';
import Button from 'reactstrap/lib/Button'; // Ensure you have reactstrap installed

const DownloadType = (props: any)=>{
  const { setDownloadType, downloadType, type, viewText } = props
  return <p style={{ color: downloadType===type? '#1e90ff': 'gray', cursor: 'pointer' }} onClick={()=>setDownloadType(type)}>{viewText}</p>
}

const PropertyQr = (props: any) => {
  const { setShowPropertyScanner, propertyExtension } = props
  const qrRef = useRef<HTMLDivElement>(null);
  const [downloadType, setDownloadType] = useState('jpeg');

  const downloadQR = (format: any) => {
    if (qrRef.current === null) {
      return;
    }

    const svg = qrRef.current.querySelector('svg');
    if (!svg) {
      return;
    }

    const svgData = new XMLSerializer().serializeToString(svg);

    if (format === 'svg') {
      const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
      const svgUrl = URL.createObjectURL(svgBlob);
      const downloadLink = document.createElement('a');
      downloadLink.href = svgUrl;
      downloadLink.download = 'qr-code.svg';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } else {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        if (ctx != null) {
          ctx.drawImage(img, 0, 0);
          let pngFile;
          if (format === 'jpeg') {
            pngFile = canvas.toDataURL('image/jpeg');
          } else {
            pngFile = canvas.toDataURL('image/png');
          }

          const downloadLink = document.createElement('a');
          downloadLink.href = pngFile;
          downloadLink.download = `qr-code.${format}`;
          downloadLink.click();
        }
      };

      img.src = 'data:image/svg+xml;base64,' + btoa(svgData);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <p style={{ width: '100%', textAlign: 'center', marginBottom: '30px' }}>Select the format below and click the <b>Download</b> button to get the QR</p>
      <div ref={qrRef} style={{ marginBottom: '20px' }}>
        <QRCode
          value={`https://app.tour24now.com/prospect/tour/${propertyExtension}/register/`}
          size={200}
          bgColor="#FFFFFF" // white background
          fgColor="#000000" // black foreground
          level="H"
        />
      </div>
      <div style={{ display: 'flex', gap: '10px'  }}>
        <h6>Download Type:</h6>
        <DownloadType setDownloadType={setDownloadType} downloadType={downloadType} type={'jpeg'} viewText={'JPEG'} />
        <DownloadType setDownloadType={setDownloadType} downloadType={downloadType} type={'png'} viewText={'PNG'} />
        <DownloadType setDownloadType={setDownloadType} downloadType={downloadType} type={'svg'} viewText={'SVG'} />
      </div>
      <div style={{ display: 'flex', gap: '10px', marginTop: '12px' }}>
        <Button color="secondary" onClick={() => setShowPropertyScanner(false)}>
          Cancel
        </Button>
        <Button color="primary" onClick={() => downloadQR(downloadType)}>
          Download
        </Button>
      </div>
    </div>
  );
};

export default PropertyQr;


// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/PropertyScanner.tsx